import { render, staticRenderFns } from "./PosVouchers.vue?vue&type=template&id=f8f003ae&scoped=true"
import script from "./PosVouchers.vue?vue&type=script&lang=js"
export * from "./PosVouchers.vue?vue&type=script&lang=js"
import style0 from "./PosVouchers.vue?vue&type=style&index=0&id=f8f003ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f003ae",
  null
  
)

export default component.exports